<div *ngIf="!authUsername && !textError; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="containerIncidencia">
    <form [formGroup]="opIncidentForm" class="containerForm">
      <div class="containerInput">
        <h1 class="title">Editar Incidencia</h1>
        <div *ngIf="!selectedService" class="service-action">
          <button
            type="button"
            class="buttonPrimarySolid"
            (click)="openDialogListServices()"
          >
            Escoger Servicio
          </button>
          <span class="service-hint">(Opcional)</span>
        </div>

        <div class="badges-row">
          <div class="badge-item">
            <i-tabler name="file" style="color: #4d4d4d !important"></i-tabler>
            <span>Nro. de File: {{ this.opIncidentTableRow.fileNumber }}</span>
          </div>

          <div class="badge-item" *ngIf="this.selectedService">
            <i-tabler
              name="pinned"
              style="color: #4d4d4d !important"
            ></i-tabler>
            <span> Servicio: {{ this.selectedService?.serviceName }} </span>
            <ng-container *ngIf="this.selectedService?.serviceProviderName"
              >; Proveedor:
              {{ this.selectedService?.serviceProviderName }}</ng-container
            >
            <i-tabler
              name="circle-x-filled"
              style="color: #4d4d4d !important; margin-left: 4px"
              (click)="removeService()"
            ></i-tabler>
          </div>
        </div>

        <div class="incidencia">
          <div class="section-header">
            <i-tabler
              name="info-circle"
              style="color: #4e5037 !important"
            ></i-tabler>
            <span>Información de Incidencia</span>
          </div>

          <div class="block">
            <div class="input-block half-width">
              <p class="custom-label">
                Tipo de Incidencia<span class="require">*</span>
              </p>
              <mat-form-field appearance="outline" class="custom-outline">
                <mat-select
                  formControlName="opIncidentType"
                  placeholder="Selecciona la Incidencia"
                >
                  <mat-option
                    *ngFor="let opIncidentType of opIncidentTypes"
                    [value]="opIncidentType"
                  >
                    {{ opIncidentType }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    opIncidentForm.get('opIncidentType')?.hasError('required')
                  "
                >
                  Requerido.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="input-block half-width">
              <p class="custom-label">Estado<span class="require">*</span></p>
              <mat-form-field appearance="outline" class="custom-outline">
                <mat-select
                  formControlName="incidentStatus"
                  placeholder="Selecciona el Estado"
                >
                  <mat-option
                    *ngFor="let status of opIncidentStatus"
                    [value]="status"
                  >
                    {{ renameOpIncidentStatus(status) }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    opIncidentForm.get('incidentStatus')?.hasError('required')
                  "
                >
                  Requerido.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="input-block full-width">
            <p class="custom-label">
              Descripción de Incidencia<span class="require">*</span>
            </p>
            <mat-form-field
              appearance="outline"
              class="custom-outline text-area-field"
            >
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="8"
                formControlName="description"
                name="descripcion"
              ></textarea>
              <mat-error
                *ngIf="opIncidentForm.get('description')?.hasError('required')"
              >
                Requerido.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="section-header">
            <i-tabler
              name="info-circle"
              style="color: #4e5037 !important"
            ></i-tabler>
            <span>Información de Resolución de Incidencia</span>
          </div>

          <div class="block">
            <div class="input-block half-width">
              <p class="custom-label">Fecha de Solución</p>
              <mat-form-field appearance="outline" class="custom-outline">
                <input
                  type="date"
                  matInput
                  formControlName="solutionDate"
                  name="solutionDate"
                />
              </mat-form-field>
            </div>

            <div class="input-block half-width">
              <p class="custom-label">Tiempo de Solución</p>
              <div class="time-solution-group">
                <mat-form-field
                  appearance="outline"
                  class="custom-outline time-input"
                >
                  <input
                    type="number"
                    matInput
                    formControlName="solutionTime"
                    name="solutionTime"
                    placeholder="Horas(s) o Día(s)"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="custom-outline time-select"
                >
                  <mat-select formControlName="solutionTimeUnit">
                    <mat-option value="Hora(s)">Hora(s)</mat-option>
                    <mat-option value="Día(s)">Día(s)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="input-block full-width">
            <p class="custom-label">Descripción de Acciones Realizadas</p>
            <mat-form-field
              appearance="outline"
              class="custom-outline text-area-field"
            >
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="8"
                formControlName="actions"
                name="actions"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="containerButtons">
      <button class="buttonSecondaryOutline" (click)="close()">Cancelar</button>
      <button
        class="buttonPrimarySolid"
        (click)="updateOpIncident()"
        [disabled]="opIncidentForm.invalid || isUpdating"
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          "
        >
          <mat-spinner *ngIf="isUpdating" diameter="20"></mat-spinner>
          <span>Actualizar</span>
        </div>
      </button>
    </div>
  </div>
</ng-template>
